import { execute, makePromise } from 'apollo-link';

import { HttpLink } from 'apollo-link-http';
import gql from 'graphql-tag';

const getStorefrontUrl = () => {
  if (process.env.REACT_APP_STOREFRONT_URL) {
    return process.env.REACT_APP_STOREFRONT_URL;
  }
  if (process.env.SERVER_ENV === 'staging') {
    return 'https://gliks-dev.myshopify.com';
  }
  return 'https://gliks-main.myshopify.com';
};

const getStorefrontAccessToken = () => {
  if (process.env.REACT_APP_STOREFRONT_ACCESS_TOKEN) {
    return process.env.REACT_APP_STOREFRONT_ACCESS_TOKEN;
  }
  if (process.env.SERVER_ENV === 'staging') {
    return '3d31a7edc47ca432a4c319391cf59b8c';
  }
  return 'e4d4b7dd84b29dee25ce38eccbf56aac';
};

const STOREFRONT_GRAPHQL_URL = `${getStorefrontUrl()}/api/2023-07/graphql.json`;
console.log(STOREFRONT_GRAPHQL_URL)
const link = new HttpLink({
  uri: STOREFRONT_GRAPHQL_URL,
  headers: {
    'Content-Type': 'application/graphql',
    'X-Shopify-Storefront-Access-Token': getStorefrontAccessToken()
  }
});

export const storefront_query = (body, variables) => {
  let operation = {};
  operation.query = gql`
    ${body}
  `;

  // add in variables to our operate if we have any
  if (typeof variables != 'undefined') {
    operation.variables = variables;
  }

  return makePromise(execute(link, operation));
};
